import { Button, Modal, message } from 'antd';
import i18next from 'i18next';
import React, { useRef, useState } from 'react';
import BgRemovePanel from './BgRemovePanel';
import { BgSession, exportSession, hasVisiblePixels } from './bgremove';
import { DTFItem } from './packing';

interface IProps {
	item: DTFItem | null;
	onApply: (id: string, out: { src: string; aspect: number }) => void;
	onClose: () => void;
}

const BgRemoveModal: React.FC<IProps> = ({ item, onApply, onClose }) => {
	const sessRef = useRef<BgSession | null>(null);
	const [, setTick] = useState(0);
	const bump = () => setTick(t => t + 1);

	if (!item) return null;
	const sess = sessRef.current;

	const apply = () => {
		const s = sessRef.current;
		if (!s || !s.dirty) return;
		if (!hasVisiblePixels(s)) {
			message.error(i18next.t('dtf.detourage-vide') as string, 5);
			return;
		}
		const out = exportSession(s);
		onApply(item.id, out);
		message.success(i18next.t('dtf.detourage-ok') as string, 4);
		onClose();
	};

	return (
		<Modal centered
			open
			title={`🎯 ${i18next.t('dtf.detourage-titre')} — ${item.name}`}
			footer={null}
			width={980}
			className="dtf-bg-modal"
			onCancel={onClose}
			maskClosable={false}
		>
			<BgRemovePanel
				src={item.src}
				sessRef={sessRef}
				onChanged={bump}
				extra={
					<>
						<Button type="primary" block className="dtf-bg-apply" disabled={!sess || !sess.dirty} onClick={apply}>
							✅ {i18next.t('dtf.detourage-valider')}
						</Button>
						<Button block className="dtf-bg-close" onClick={onClose}>
							{i18next.t('dtf.fermer')}
						</Button>
					</>
				}
			/>
		</Modal>
	);
};

export default BgRemoveModal;
